"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SigmaModelParametersComparison = void 0;
const si_comparison_1 = require("../../Comparison/si-comparison");
const value_comparison_1 = require("../../Comparison/value-comparison");
const comparison_spec_1 = require("../comparison-spec");
class SigmaModelParametersComparison extends comparison_spec_1.ComparisonSpec {
    constructor(aliases = {}, paramUnits = {}) {
        super();
        this.alignment = new comparison_spec_1.CellAlignment(['paramName'], ['value', 'variance', 'notSpecified']);
        this.normalizedAliases = new Map(Object.entries(aliases).map(([alias, canonical]) => [alias.trim().toLowerCase(), canonical.trim().toLowerCase()]));
        this.canonicalDisplay = new Map(Object.values(aliases).map((canonical) => [canonical.trim().toLowerCase(), canonical.trim()]));
        this.paramUnits = new Map(Object.entries(paramUnits).map(([name, declaration]) => [name.trim().toLowerCase(), declaration]));
    }
    toRows(data) {
        return Object.entries(data).map(([paramName, pair]) => ({
            paramName,
            value: pair.value,
            variance: pair.variance,
            ...(pair.notSpecified === true ? { notSpecified: true } : {}),
        }));
    }
    fromRows(rows) {
        const result = {};
        for (const row of rows) {
            result[row.paramName] = {
                value: row.value ?? null,
                variance: row.variance ?? null,
                ...(row.notSpecified === true ? { notSpecified: true } : {}),
            };
        }
        return result;
    }
    rowKeyOf(row) {
        return (0, value_comparison_1.compositeKey)(row, this.alignment.keyColumns.map(String), (column, value, rowContext) => this.normalize(column, value, rowContext));
    }
    normalize(column, value, row) {
        if (column === 'paramName') {
            return this.resolveParamName(value);
        }
        if (column === 'value' && typeof value === 'string') {
            const declaration = this.unitsFor(row);
            return declaration !== undefined ?
                (0, si_comparison_1.formatSIOrSymbolicValueWithDeclaration)(value, declaration)
                : super.normalize(column, value, row);
        }
        if (column === 'variance' && typeof value === 'string') {
            return (0, si_comparison_1.formatVariance)(value);
        }
        return super.normalize(column, value, row);
    }
    canonicalizeKeys(row) {
        const resolved = this.resolveParamName(row.paramName);
        return { ...row, paramName: this.canonicalDisplay.get(resolved) ?? row.paramName };
    }
    unitsFor(row) {
        return row?.paramName === undefined ? undefined : this.paramUnits.get(this.resolveParamName(row.paramName));
    }
    resolveParamName(value) {
        const raw = typeof value === 'string' ? value.trim() : super.normalize('paramName', value);
        const lowered = raw.toLowerCase();
        return this.normalizedAliases.get(lowered) ?? lowered;
    }
}
exports.SigmaModelParametersComparison = SigmaModelParametersComparison;
//# sourceMappingURL=sigma-model-parameters.comparison.js.map